'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dBased$002dOn$002dResult from "./app.pages.-Document-Templates-Create-Page$-Based-On-Result.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.aib = null;
  this.aXz = 0;
  this.aib = \u03b4name$4;
  this.aXz = _$ordinal$4;
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 as $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2.prototype = new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dBased$002dOn$002dResult.$h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 as $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 };
$h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.aib;
});
$p.n = (function() {
  return this.aib;
});
$p.co = (function() {
  return this.aXz;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2, "app.pages.DocumentTemplatesCreatePage$BasedOnResult$$anon$2", ({
  Hv: 1,
  kh: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 as $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2 };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Based-On-Result$$anon$2.js.map
